module.exports = __webpack_public_path__ + "static/media/Illustration3.a545073e.png";